import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {ReactiveFormsModule} from '@angular/forms';

import {MessageService} from 'primeng/api';
import {PanelModule} from 'primeng/panel';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import {PaginatorModule} from 'primeng/paginator';
import { DialogModule } from 'primeng/dialog';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {CardModule} from 'primeng/card';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {CalendarModule} from 'primeng/calendar';
import {TabViewModule} from 'primeng/tabview';
import {RadioButtonModule} from 'primeng/radiobutton';
import {MultiSelectModule} from 'primeng/multiselect';
import {TabMenuModule} from 'primeng/tabmenu';
import {CheckboxModule} from 'primeng/checkbox';
import {TooltipModule} from 'primeng/tooltip';
import {ToastModule} from 'primeng/toast';

import { InicioComponent } from './components/inicio/inicio.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CapacitacionesUserComponent } from './components/capacitaciones-user/capacitaciones-user.component';
import { CursosDisponibleComponent } from './components/cursos-disponible/cursos-disponible.component';
import { CursosInscritoComponent } from './components/cursos-inscrito/cursos-inscrito.component';
import { LoginComponent } from './components/login/login.component';
import { AuthService, JwtInterceptor, ErrorInterceptor } from './_helpers';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CursoInscritoDetalleComponent } from './components/curso-inscrito-detalle/curso-inscrito-detalle.component';
import { VisorPdfComponent } from './components/cursos-inscrito/visor-pdf/visor-pdf.component';
// import { CursosService } from './services/cursos.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { VisorVideoComponent } from './components/cursos-inscrito/visor-video/visor-video.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { UsuarioInfoComponent } from './components/usuario-info/usuario-info.component'; // <- import PdfViewerModule
// import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@NgModule({
  declarations: [
    AppComponent,
    InicioComponent,
    DashboardComponent,
    CapacitacionesUserComponent,
    CursosDisponibleComponent,
    CursosInscritoComponent,
    LoginComponent,
    CursoInscritoDetalleComponent,
    VisorPdfComponent,
    VisorVideoComponent,
    ResetPasswordComponent,
    UsuarioInfoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    BrowserModule,
    PanelModule,
    DropdownModule,
    ButtonModule,
    FormsModule,
    TableModule,
    PaginatorModule,
    DialogModule,
    InputTextareaModule,
    CardModule,
    ScrollPanelModule,
    ConfirmDialogModule,
    CalendarModule,
    TabMenuModule,
    TabViewModule,
    RadioButtonModule,
    CheckboxModule,
    TooltipModule,
    MultiSelectModule,
    ReactiveFormsModule,
    ToastModule,
    PdfViewerModule, 
    PdfJsViewerModule 
    // NgxExtendedPdfViewerModule
  ],
  providers: [
		MessageService,
    AuthService,
		{provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
		{provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
